module.exports = {"350304001":"镇海街道","350304002":"拱辰街道","350304100":"西天尾镇","350304101":"黄石镇","350304102":"新度镇","350304103":"北高镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350304.json
// module id = 1086
// module chunks = 0